const Shared = {

    //backend to frontend format
    //ie: 13:30:00 to 1:30 pm
    toFETime: function(value) {
        let hour = parseInt(value.substring(0, 2));
        const min = parseInt(value.substring(3, 5));

        let isPm = false;
        if(hour === 12) {
            isPm = true;
        }
        if(hour > 12) {
            hour -= 12;
            isPm = true;
        }

        let formatted = "" + hour + ":" + min;
        if(min === 0) {
            formatted += "0"
        }
        formatted += isPm ? " pm" : " am";

        return formatted;
    },

    //frontend to backend format
    //returns null if invalid
    toBETime: function(value) {
        if(!value) {
            return;
        }
        
        const amPm = value.slice(-2);
        if(amPm === "am" || amPm === "pm") {}
        else {
            return null; //invalid
        }

        let hour = value.substring(0, 2);
        if(hour.includes(":")) {
            hour = value.substring(0, 1);
        }

        let num = parseInt(hour);
        if(isNaN(num)) {
            return null; //invalid
        }
        if(num < 1 || num > 12) {
            return null;
        }

        if(num === 12) {
            if(amPm === "am") {
                num = 0;
            }
        }
        else if(amPm === "pm") {
            num += 12;
        }
        if(num < 0 || num > 23) {
            return null;
        }

        let min = "00";
        let i = value.indexOf(":");
        if(i > -1) {
            min = value.substring(i + 1, i + 3);
        }
        if(min.includes(" ")) {
            return null;
        }

        let formatted = "";
        if(num < 10) {
            formatted += "0";
        }
        formatted += num;
        formatted += ":" + min + ":00";
        return formatted;
    },
};

export default Shared;